<template>
  <div>
    <v-card-text class="pa-0" style="height: 500px; overflow-y: auto;">
      <v-layout class="pa-2" row wrap style="height: auto;" v-if="template">
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-text-field v-model="template.title" label="Title"></v-text-field>
          <v-text-field v-model="template.name" label="Name"></v-text-field>
          <v-text-field v-model="template.meta.weight" label="Weight" v-if="template.type == 'template'"></v-text-field>

          <group-channel-select :id="id" type="template" label="Channels" mode="readonly" v-model="selected_channels"></group-channel-select>

        </v-flex>
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <json-editor v-model="configuration"></json-editor>
          
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="error" v-show="is_edit && template.state != 'archived'" @click="changeState('archived')">Archive</v-btn>
      <v-btn color="error" v-show="is_edit && template.state == 'archived'" @click="changeState('active')">Unarchive</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import JsonEditor from '@/components/JsonEditor'
import GroupChannelSelect from './GroupChannelSelect'

export default {
  components: {
    JsonEditor,
    GroupChannelSelect
  },
    props: ["id"],
  data () {
    var ch = this.$cloudserver.channel("channels:group:"+(this.id||"create:template"));
    return {
      ws_channel: ch,
      template: this.convertTemplate(ch.data)
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.template = this.convertTemplate(newVal, oldVal);
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        this.ws_channel = this.$cloudserver.channel("channels:group:"+(this.id||"create:template"));
        this.ws_channel.join();
      }
    }
  },
  created () {
    this.ws_channel.join();
  },
  computed: {
    configuration: {
      get () {
        return _.get(this.template, "meta.configuration", {});
      },
      set (newValue) {
        _.set(this.template, "meta.configuration", newValue);
      }
    },
    is_edit () {
      return typeof(this.template) != "undefined" && this.template.uuid != null;
    },
  },
  methods: {
    changeState (state) {
      this.template.state = state;
      this.save(false);
    },
    save(close) {
      if(typeof(this.ws_channel) != "undefined") {
        var self = this;
        var template = _.cloneDeep(this.template);

        this.ws_channel.save({channel_group: template})
          .then((msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("Configuration preset was created!");
            } else {
              self.$message.success("Configuration preset was updated!");
            }
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.channel_group.uuid}})
            }
          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create configuration preset!");
            } else {
              self.$message.warning("Unable to update configuration preset!");
            }
          });
      }
    },
    reset () {
      this.template = this.convertTemplate(this.ws_channel.data);
    },
    convertTemplate (newVal, oldVal) {
      var template = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }

      if(typeof(template) == "undefined" || _.isEmpty(template)) return undefined;
      return template;
    }
  }
}
</script>